var map = {
	"./Article_0/banner.jpg": "6oAe",
	"./Article_1/banner.jpg": "eR94",
	"./Article_10/banner.jpg": "Ou/8",
	"./Article_11/banner.jpg": "j8O1",
	"./Article_12/banner.jpg": "6TA8",
	"./Article_13/banner.jpg": "8azY",
	"./Article_2/banner.jpg": "6uth",
	"./Article_3/banner.jpg": "z/m2",
	"./Article_4/banner.jpg": "0mvb",
	"./Article_5/banner.jpg": "XEsp",
	"./Article_6/banner.jpg": "0bfB",
	"./Article_7/banner.jpg": "PLYe",
	"./Article_8/banner.jpg": "UtyB",
	"./Article_9/banner.jpg": "C+bJ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ptt8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles ^\.\/Article_.*\/banner\.jpg$
// module id = ptt8
// module chunks = 0